import {
  BASENAME,
  OKTA_CLIENT_ID,
  OKTA_ISSUER,
  OKTA_REDIRECT_URI
} from '../constants/constants'

export default {
  oidc: {
    clientId: OKTA_CLIENT_ID,
    issuer: OKTA_ISSUER,
    redirectUri: OKTA_REDIRECT_URI,
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
    disableHttpsCheck: false
  },
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages'
  },
  app: {
    basename: BASENAME
  }
}
